enum StatusNegociacaoParticularEnum {
  Aprovado = 'Aprovado',
  Negado = 'Negado',
  EmAnalise = 'EmAnalise',
}

export default StatusNegociacaoParticularEnum
